var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "popupsWrapper",
      staticClass: "v-popups__wrapper",
      on: {
        click: _vm.handleClick,
        mouseenter: _vm.handleMouseenter,
        mouseleave: _vm.handleMouseleave,
      },
    },
    [
      _c("transition", { attrs: { name: _vm.transition } }, [
        _vm.visible
          ? _c(
              "div",
              {
                directives: [
                  {
                    name: "clickoutside",
                    rawName: "v-clickoutside",
                    value: _vm.handleClickOutside,
                    expression: "handleClickOutside",
                  },
                ],
                ref: "popups",
                class: ["v-popups", `v-popups--${_vm.effect}`, _vm.customClass],
                style: _vm.popupsStyle,
                on: {
                  mouseenter: _vm.handlePopupsEnter,
                  mouseleave: _vm.handlePopupsLeave,
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "v-popups__main", style: _vm.customStyle },
                  [_vm._t("default")],
                  2
                ),
                _c(
                  "svg",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showArrow,
                        expression: "showArrow",
                      },
                    ],
                    class: ["v-popups__arrow"],
                    style: _vm.arrowStyle,
                  },
                  [_c("polygon", { attrs: { points: _vm.polygonPoints } })]
                ),
              ]
            )
          : _vm._e(),
      ]),
      _vm._t("reference", null, { visible: _vm.visible }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }